import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import {
  Alert,
  Icon,
  Layout,
  Input,
  Table,
  Badge,
  Select, TreeSelect
} from 'antd';
import cloneDeep from "lodash/cloneDeep";

import classes from './DocumentsPharmacyBinder.css';

import isAuthenticated from '../../utils/isAuthenticated';
import {
  getDocumentsPharmacyBinder,
  getEtmfDocumentSchemaFilterRequest,
} from '../../api/requests';
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from 'react-i18next';
import FileLink from "../../components/FileLink/FileLink";

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;
const { TreeNode } = TreeSelect;


class DocumentsPharmacyBinder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      documents: [],
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      site: null,
      filter: null,
      order: 'asc',
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      sortedInfo: { columnKey: 'order_index', order: 'ascend'},
      documentEdit: null,
      filterBy: null,
      filterValue: null,
      filtersBy: ['content_type_code'],
      filtersValue: [],
      etmfSchema: {},
    };
  }

  async componentDidMount() {
    this.onNameSearch();
    const { data: etmfSchema } = await getEtmfDocumentSchemaFilterRequest('pharmacy_binder');
    this.setState({ etmfSchema });
  }

  onNameSearch = async (value) => {
    this.setState({ nameSearch: value, filter: null, site: null,filterBy: null, filterValue: null, eventsSelected: {}, currentPage: 1 }, this.getDocuments);
  };

  getDocuments = async (page = this.state.currentPage, per_page = this.state.pageSize) => {
    this.setState({ errorMessage: null, isLoading: true, responseMessage: null });

    try {
      const { data } = await getDocumentsPharmacyBinder({
        nameSearch: this.state.nameSearch,
        order_direction: this.state.order,
        page,
        per_page,
        order_column: get(this.state, 'sortedInfo.columnKey'),
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
      });

      if (Array.isArray(data.data)) {
        this.setState({ documents: data.data, total: data.total_pages * per_page, currentPage: page });
      } else {
        this.setState({ documents: [data], total: 1 * per_page, currentPage: page });
      }
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      this.setState({ documents: null, errorMessage: get(e, 'response.data.error', 'Error') });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      isLoading: true,
      pageSize: pagination.pageSize,
      sortedInfo: sorter,
      order: get(sorter, 'order') === 'ascend' ? 'asc' : get(sorter, 'order') === 'descend' ? 'desc' : 'asc',
    }, () => this.getDocuments(pagination.current, pagination.pageSize));
  };

  handleFilterChange = index => value => {
    this.setState(state => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);
      filtersBy[index] = value;
      delete filtersValue[index];
      return { filtersBy, filtersValue };
    });
  };
  handleFilterValueChange = index => value => { this.setState(state => {
    let filtersValue = cloneDeep(state.filtersValue);
    filtersValue[index] = value;

    if (!filtersValue[index] || !filtersValue[index].length) {
      filtersValue = [];
    }
    return { filtersValue, currentPage: 1 };
  }, this.getDocuments) };

  clearFilter = index => () => { this.setState(state => {
    const filtersBy = cloneDeep(state.filtersBy);
    const filtersValue = cloneDeep(state.filtersValue);

    filtersBy.splice(index, 1);
    filtersValue.splice(index, 1);

    return { filtersBy, filtersValue, currentPage: 1 };

  }, this.getDocuments)};

  clearFilters = () => { this.setState({ nameSearch: null, currentPage: 1 }, this.getDocuments); };

  renderFilterItem = (index = this.state.filtersBy.length) => {
    const {filtersBy, filtersValue, sites, etmfSchema } = this.state;

    return (
      <div className={classes.wrapperFilterItem} key={filtersBy[index]}>
        <div className={classes.searchWrapperFilter}>
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>{this.props.i18n.t('Filter by')}</b>
            <Select disabled onChange={this.handleFilterChange(index)} value={filtersBy[index]} style={{width: '100%'}} placeholder={this.props.i18n.t('Select')}>
              <Option value='content_type_code' disabled={filtersBy.includes('content_type_code')}>{this.props.i18n.t('Content type')}</Option>
            </Select>
          </label>
        </div>

        {filtersBy[index] === 'content_type_code' && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Content type")}
            </b>
            <TreeSelect
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              placeholder={this.props.i18n.t("Select content type")}
              style={{ width: "100%" }}
              allowClear
            >
              {get(etmfSchema, "schema", []).map(
                ({ code, name, sub_categories }) => (
                  <TreeNode
                    key={code}
                    title={<b style={{ color: "#777" }}>{name}</b>}
                    value={code}
                    selectable={false}
                  >
                    {sub_categories &&
                      sub_categories.length > 0 &&
                      sub_categories.map(({ name, code, content_types }) => (
                        <TreeNode
                          key={code}
                          title={<b style={{ color: "#777" }}>{name}</b>}
                          value={code}
                          selectable={false}
                        >
                          {content_types &&
                            content_types.length > 0 &&
                            content_types.map(({ name, code }) => (
                              <TreeNode key={code} title={name} value={code} />
                            ))}
                        </TreeNode>
                      ))}
                  </TreeNode>
                )
              )}
            </TreeSelect>
          </label>
        )}
      </div>
    );
  };

  render() {
    const { errorMessage, isLoading, responseMessage, nameSearch, documents, currentPage, total, pageSize, sortedInfo, filtersBy } = this.state;

    const columns = [
      {
        dataIndex: "order_index",
        key: "order_index",
        title: this.props.i18n.t('Index'),
        render: val => (<span>{val}</span>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'order_index' && sortedInfo.order,
      },
      {
        dataIndex: "name",
        key: "name",
        title: this.props.i18n.t('Document Name'),
        render: (val, record) => (<div className={classes.nameDocumentWrapper}>
          <div style={{ width: '86px' }}>
            <Badge count={record.state} style={{ backgroundColor: record.state === 'active' ? '#52c41a' : '#777' }} />
            <br/>
            {record.state === 'active' && <Badge count={record.approved ? 'approved' : 'unapproved'} style={{ backgroundColor: record.approved ? '#52c41a' : '#777' }} />}

          </div>
          {val}
        </div>),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'name' && sortedInfo.order,
      },
      {
        dataIndex: "content_type_name",
        key: "content_type_name",
        title: this.props.i18n.t("Content type"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "content_type_name" &&
          sortedInfo.order,
      },
      {
        dataIndex: "site",
        key: "site",
        title: this.props.i18n.t("Site"),
        render: (site) => get(site, "name"),
        sorter: true,
        sortOrder: get(sortedInfo, "columnKey") === "site" && sortedInfo.order,
      },
      {
        dataIndex: "start_year",
        key: "start_year",
        title: this.props.i18n.t('Start date'),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'start_year' && sortedInfo.order,
      },
      {
        dataIndex: "expiry_year",
        key: "expiry_year",
        title: this.props.i18n.t('Expiry date'),
        sorter: true,
        sortOrder: get(sortedInfo, 'columnKey') === 'expiry_year' && sortedInfo.order,
      },
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t('Actions'),
        render: (val, document) => (<div className={classes.actions}>
          <FileLink url={document.url} />
        </div>)
      },
    ];

    return (
        <div style={{ backgroundColor: '#FAFAFA' }}>
            <Layout className={classes.parentContainer}>

                <Content className={classes.content}>
                  <h3 className='headline-default'>{this.props.i18n.t('NamespaceDocumentsPharmacyBinder:Pharmacy Binder Documents')}</h3>

                  <div className={classes.searchWrapper}>
                    <label className={classes.searchWrapperSearch}>
                      <b className={classes.searchWrapperLabel}>{this.props.i18n.t('SEARCH')}</b>
                      <Search
                        placeholder={this.props.i18n.t('By name')}
                        enterButton={this.props.i18n.t('Search')}
                        size="large"
                        onSearch={this.onNameSearch}
                        value={nameSearch}
                        onChange={this.onNameChange}
                        style={{ maxWidth: '500px'}}
                      />
                    </label>
                  </div>

                  <h4 className='headline-default'>{this.props.i18n.t('Filter')}</h4>

                  <div className={classes.wrapperFilters}>
                    {filtersBy.map((_, index) => this.renderFilterItem(index))}
                  </div>

                  {errorMessage && (<Alert type='error' message={errorMessage} />)}

                  {responseMessage && (<Alert type='success' message={responseMessage} />)}

                  <Table
                    columns={columns}
                    dataSource={documents}
                    loading={isLoading}
                    rowKey="id"
                    onChange={this.handleTableChange}
                    pagination={{
                      onShowSizeChange: (current, size) => {
                        this.setState({ pageSize: size });
                      },
                      current: currentPage,
                      total,
                      pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: ['10', '25', '50', '100'],
                      position: 'both',
                    }}
                  />

                  {isLoading && <Icon type="loading" />}
                </Content>

            </Layout>
        </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { logout };

export default isAuthenticated(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(DocumentsPharmacyBinder)));



// WEBPACK FOOTER //
// ./src/containers/DocumentsPharmacyBinder/DocumentsPharmacyBinder.js